var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_856_6974)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_856_6974",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5828,
    cy: 12,
    r: 12,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_856_6974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.27305 -9.86538C9.27445 -10.6352 10.0973 -11.1566 10.794 -10.8291C16.6365 -8.0828 25.0095 -5.39565 28.3944 -0.0537352C31.7792 5.28818 30.6333 14.0067 30.6216 20.4623C30.6202 21.2321 29.7973 21.7535 29.1007 21.426C23.2582 18.6797 14.8852 15.9926 11.5003 10.6507C8.11547 5.30877 9.26135 -3.40977 9.27305 -9.86538Z",
    fill: "#E2BBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9187 -5.22591C15.8733 -6.32953 14.9378 -7.20005 13.8484 -7.01733C12.4413 -6.7813 11.069 -6.35758 9.76888 -5.75521C7.86244 -4.8719 6.14864 -3.62173 4.72534 -2.07609C3.30205 -0.530449 2.19712 1.2804 1.47365 3.25305C0.980282 4.59829 0.6709 6.0008 0.551436 7.42266C0.458957 8.52334 1.40349 9.38403 2.50711 9.33855L14.4968 8.84448C15.6004 8.799 16.4582 7.86747 16.4127 6.76384L15.9187 -5.22591Z",
    fill: "#66B1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9873 13.1472C13.0415 12.8176 13.6434 11.6849 13.1435 10.6999C12.0218 8.48985 10.2344 6.66534 8.00988 5.50041C5.19052 4.02394 1.90011 3.72792 -1.1375 4.67748C-4.17511 5.62705 -6.71109 7.7444 -8.18756 10.5638C-9.3525 12.7882 -9.78257 15.3059 -9.4458 17.7614C-9.29571 18.8557 -8.15584 19.444 -7.10159 19.1144L2.44284 16.1308L11.9873 13.1472Z",
    fill: "#267CBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29105 28.6582C2.82454 28.9538 2.68275 29.5746 3.01615 30.0149C4.24053 31.6319 5.85852 32.9167 7.72288 33.7425C9.89289 34.7037 12.2992 34.9998 14.6375 34.5934C16.9758 34.187 19.1411 33.0964 20.8595 31.4594C22.578 29.8223 23.7724 27.7125 24.2918 25.3967C24.8112 23.0808 24.6322 20.6629 23.7774 18.4488C22.9227 16.2347 21.4305 14.3238 19.4898 12.9577C17.549 11.5916 15.2467 10.8318 12.874 10.7742C10.8356 10.7247 8.82381 11.1955 7.02616 12.1347C6.53666 12.3904 6.39974 13.0124 6.69533 13.4789L12.0475 21.9259C12.3431 22.3925 12.2046 23.0103 11.7381 23.3059L3.29105 28.6582Z",
    fill: "#CFE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.30852 29.1734C-4.06096 29.3359 -4.75263 28.6442 -4.59011 27.8918C-3.46773 22.6951 -2.77041 15.6366 0.86622 11.9998C4.50285 8.36307 11.5612 7.6656 16.7577 6.54309C17.5102 6.38056 18.2018 7.07222 18.0393 7.82467C16.9169 13.0214 16.2196 20.0798 12.583 23.7166C8.94635 27.3534 1.88804 28.0508 -3.30852 29.1734Z",
    fill: "#FFD6F7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_856_6974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.582764)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg3);
export default __webpack_public_path__ + "static/media/profileImg3.51cec61ab8906c9fd619e8fbb4b6c783.svg";
export { ForwardRef as ReactComponent };